import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import AutoScorllTop from "./AutoTop.js";
import "./index.scss";
import App from "./App";
import EnLicense from "./text/en/license.js";
import EnPrivacy from "./text/en/privacyPolicy.js";
import ZhLicense from "./text/zh/license.js";
import ZhPrivacy from "./text/zh/privacyPolicy.js";
import RULicense from "./text/ru/license.js";
import RUPrivacy from "./text/ru/privacyPolicy";
import ZHHKlicence from "./text/zh-hk/license";
import ZHHKPrivacy from "./text/zh-hk/privacyPolicy";
import ZHTWLicense from "./text/zh-tw/license";
import ZHTWPrivacy from "./text/zh-tw/privacyPolicy";
import DeLicense from "./text/de/license";
import DePrivacy from "./text/de/privacyPolicy";
import EsLicense from "./text/es/license";
import EsPrivacy from "./text/es/privacyPolicy";
import FrLicense from "./text/fr/license";
import FrPrivacy from "./text/fr/privacyPolicy";
import IdLicense from "./text/id/license";
import IdPrivacy from "./text/id/privacyPolicy";
import ItLicense from "./text/it/license";
import ItPrivacy from "./text/it/privacyPolicy";
import JaLicense from "./text/ja/license";
import JaPrivacy from "./text/ja/privacyPolicy";
import KoLicense from "./text/ko/license";
import KoPrivacy from "./text/ko/privacyPolicy";
import PlLicense from "./text/pl/license";
import PlPrivacy from "./text/pl/privacyPolicy";
import TrLicense from "./text/tr/license";
import TrPrivacy from "./text/tr/privacyPolicy";
import UkLicense from "./text/uk/license";
import UkPrivacy from "./text/uk/privacyPolicy";
import ViLicense from "./text/vi/license";
import ViPrivacy from "./text/vi/privacyPolicy";
import ThLicense from "./text/th/license";
import ThPrivacy from "./text/th/privacyPolicy";
import reportWebVitals from "./reportWebVitals";

ReactDOM.render(
  <React.StrictMode>
    <Router>
      <AutoScorllTop>
        <Switch>
          <Route exact={true} path="/" component={App}></Route>
          <Route exact={true} path="/enLicense" component={EnLicense} />
          <Route exact={true} path="/enPrivacy" component={EnPrivacy} />
          <Route exact={true} path="/zhLicense" component={ZhLicense} />
          <Route exact={true} path="/zhPrivacy" component={ZhPrivacy} />
          <Route exact={true} path="/ruLicense" component={RULicense} />
          <Route exact={true} path="/ruPrivacy" component={RUPrivacy} />
          <Route exact={true} path="/zh-hkLicense" component={ZHHKlicence} />
          <Route exact={true} path="/zh-hkPrivacy" component={ZHHKPrivacy} />
          <Route exact={true} path="/zh-twLicense" component={ZHTWLicense} />
          <Route exact={true} path="/zh-twPrivacy" component={ZHTWPrivacy} />
          <Route exact={true} path="/deLicense" component={DeLicense} />
          <Route exact={true} path="/dePrivacy" component={DePrivacy} />
          <Route exact={true} path="/esLicense" component={EsLicense} />
          <Route exact={true} path="/esPrivacy" component={EsPrivacy} />
          <Route exact={true} path="/frLicense" component={FrLicense} />
          <Route exact={true} path="/frPrivacy" component={FrPrivacy} />
          <Route exact={true} path="/idLicense" component={IdLicense} />
          <Route exact={true} path="/idPrivacy" component={IdPrivacy} />
          <Route exact={true} path="/itLicense" component={ItLicense} />
          <Route exact={true} path="/itPrivacy" component={ItPrivacy} />
          <Route exact={true} path="/jaLicense" component={JaLicense} />
          <Route exact={true} path="/jaPrivacy" component={JaPrivacy} />
          <Route exact={true} path="/koLicense" component={KoLicense} />
          <Route exact={true} path="/koPrivacy" component={KoPrivacy} />
          <Route exact={true} path="/plLicense" component={PlLicense} />
          <Route exact={true} path="/plPrivacy" component={PlPrivacy} />
          <Route exact={true} path="/thLicense" component={ThLicense} />
          <Route exact={true} path="/thPrivacy" component={ThPrivacy} />
          <Route exact={true} path="/trLicense" component={TrLicense} />
          <Route exact={true} path="/trPrivacy" component={TrPrivacy} />
          <Route exact={true} path="/ukLicense" component={UkLicense} />
          <Route exact={true} path="/ukPrivacy" component={UkPrivacy} />
          <Route exact={true} path="/viLicense" component={ViLicense} />
          <Route exact={true} path="/viPrivacy" component={ViPrivacy} />
        </Switch>
      </AutoScorllTop>
    </Router>
    ,
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
